module.exports = __webpack_public_path__ + "static/img/iit_function_h5.4c5376d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/iit_function_h5.png
// module id = 24TV
// module chunks = 34